import { render, staticRenderFns } from "./PageSummaryDisplay.vue?vue&type=template&id=547fcf9e"
import script from "./PageSummaryDisplay.vue?vue&type=script&lang=js"
export * from "./PageSummaryDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports